import Services from '@/services/index';
import VT from '@/store/types';

export default {
  [VT.PROJECT_LOAD]: ({ commit, getters }, id) => {
    if (getters['currentProjectId'] !== id) {
      commit(VT.PROJECT_LOAD, null);
    }

    return new Promise((resolve, reject) => {
      Services.projects.info(id).then((data) => {
        commit(VT.PROJECT_LOAD, data);
        resolve(data);
      }).catch((data) => {
        commit(VT.PROJECT_LOAD, null);
        reject(data);
      });
    });
  },
};
